import jQuery from 'jquery';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';

import Loading from './Loading';
import { postPessoa } from '../../actions';
import Formulario from '../../components/Configuracoes/Formulario';
import Footer from '../Footer';
import { correctHeight, detectBody } from '../helpers';
import Navigation from '../Navigation';
import Topnavbar from '../TopNavbar';

const BasicLayout = ({
  children,
  postAction,
  usuario: { carregandoAplicacao, pessoaLogada, dadosPessoa },
}) => {
  useEffect(() => {
    jQuery(window).bind('load resize', () => {
      correctHeight();
      detectBody();
    });
  });

  if (carregandoAplicacao)
    return (
      <Fragment>
        <Loading title="Estamos preparando tudo para você! Aguarde..." type="bars" />
        {children}
      </Fragment>
    );

  if (pessoaLogada.pessoaUsuarioJaExiste)
    return (
      <div id="wrapper">
        <Navigation />

        <div id="page-wrapper" className="gray-bg">
          <Topnavbar />

          {children}

          <Footer />
        </div>
      </div>
    );

  return (
    <div id="bg-acesso">
      <div className="container-acesso">
        <div className="row m-t">
          <div className="col-sm-12 b-r">
            <h3 className="m-t-none m-b text-center">Dados do Usuário</h3>

            <p>Para continuar o acesso é necessário que você finalize seu cadastro.</p>

            <Formulario initialValues={dadosPessoa} onSubmit={postAction} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({ usuario: state.usuario });

const mapDispatchToProps = {
  postAction: postPessoa,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasicLayout);
